// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ln-z","badgeLink":"Mn-z","category":"Nn-z"};